import styled from 'styled-components';

import { ErrorMessageWrapper } from '~/components/error-message-wrapper/ErrorMessageWrapper';

export const StyledErrorMessageWrapper = styled(ErrorMessageWrapper)`
  text-align: center;
  border: none;
`;
